<template>
<div class="page page_comment">
    <van-tabs v-model="active" @change="changeTab">
        <van-tab title="商品评论" name="a"></van-tab>
        <!-- <van-tab title="头条评论" name="b"></van-tab> -->
        <van-tab title="项目评论" name="c"></van-tab>
    </van-tabs>
    <!-- 商品评论 -->
    <div class="list" v-if="active == 'a'">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getGoodsComment">
            <div class="item" v-for="(goods,index) in goodsCommentList" :key="index">
                <div class="item_t" v-if="goods.user">
                    <img :src="goods.user.thumb ? ($publicData.withHttpStart(goods.user.thumb) ? goods.user.thumb : imageUrl+goods.user.thumb ) : $publicData.defaultTouxiang" alt="" class="thumb">
                    <div class="item_t_r">
                        <div class="user_name">{{ goods.user.nickname }}</div>
                        <div class="time">{{ goods.created_at }}</div>
                    </div>
                </div>
                <div class="item_nr">
                    <span class="comment_er">{{goods.user.nickname +'：'}}</span>
                    <span class="comment_txt">{{ goods.content }}</span>
                    <span class="comment_txt looktu" v-if="goods.attrs && goods.attrs.length" @click="zhanshitupian(goods.attrs,index)">[查看图片]</span>
                </div>
                <div class="item_goods" v-if="goods.good" @click="goodsDetail(goods.good_id)">
                    <div :class="goods.good.goodset && goods.good.goodset.is_blockchain ? 'goods_img blockchain' : 'goods_img'">
                        <img :src="goods.good.thumb ? imageUrl+goods.good.thumb  : $publicData.intangibleDefault" alt="" class="tu">
                    </div>
                    <div class="goods_nr">
                        <div class="goods_title slh_s">{{goods.good.title}}</div>
                        <div class="goods_desc slh">{{ goods.good.describe }}</div>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
    <!-- 项目评论 -->
    <div class="list" v-if="active == 'c'">
        <van-list v-model="loading_item" :finished="finished_item" finished-text="没有更多了" @load="getItemComment" :immediate-check="false">
            <div class="item" v-for="(item,index) in itemCommentList" :key="index">
                <div class="item_t" v-if="item.userdata">
                    <img :src="item.userdata.thumb ? ( $publicData.withHttpStart(item.userdata.thumb) ? item.userdata.thumb : imageUrl+item.userdata.thumb ) : $publicData.defaultTouxiang" alt="" class="thumb">
                    <div class="item_t_r">
                        <div class="user_name">{{item.userdata.nickname }}</div>
                        <div class="time">{{ item.created_at }}</div>
                    </div>
                </div>
                <div class="item_nr">
                    <span class="comment_er">{{item.userdata.nickname +'：'}}</span>
                    <span class="comment_txt">{{ item.comment }}</span>
                    <span class="comment_txt looktu" v-if="item.attrShow && item.attrShow.length" @click="zhanshitupian(item.attrShow,index)">[查看图片]</span>
                </div>
                <div class="item_goods" v-if="item.location" @click="itemDetail(item.location.id)">
                    <div class="goods_img">
                        <img :src="item.location.item.thumb ? imageUrl+item.location.item.thumb  : $publicData.intangibleDefault" alt="" class="tu">
                    </div>
                    <div class="goods_nr">
                        <div class="goods_title slh_s">{{item.location.item.title}}</div>
                        <div class="goods_desc slh">{{ item.location.item.describe }}</div>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
    <!-- 大图预览 -->
    <van-image-preview v-model="bigTuShow" :start-position="bigTuIndex" :images="bigTuImgArr" @change="bigTuChange"></van-image-preview>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            active: 'a',
            goodsCommentList: [],
            itemCommentList: [],
            bigTuShow: false, // 大图预览状态
            bigTuIndex: 0, // 大图初始索引
            bigTuImgArr: null, // 大图数组
            pages: {
                page: 1,
                size: 10
            },
            loading: false,
			finished: false,
			loading_item: false,
            finished_item: false,
            token:''
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '我的评论'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log('sdjy://member/memberInfo')
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getGoodsComment()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // this.getData()
                responseCallback({})
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
            // this.getGoodsComment();
        }
    },
    methods: {
        // 获取列表
        // getData() {
        //     var token = this.$store.getters.token;
        //     var param = {};
        //     this.getGoodsComment()
        //     this.getItemComment()
        // },
        //商品评论
        getGoodsComment() {
            if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var token = this.token;
            var param = {
                token: token,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.my.goodsCommentList(param).then(res => {
                if (res.code == 200) {
                    var list = res.result
                    for (var i in list) {
                        this.goodsCommentList.push(list[i])
                    }
                    if (list.length == 0) {
                        // 数据全部加载完
                        this.finished = true
                        return;
                    }
                } else {
                    this.$toast(res.message)
                    this.finished = true
                    return
                }
                this.pages.page++;
                this.loading = false;
            })
        },
        //项目评论
        getItemComment() {
			if(!this.loading_item){
				return
			}
			// console.log('调起 -----')
            var param = {
                token: this.token,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.my.itemCommentList(param).then(res => {
                if (res.code == 200) {
                    var list = res.result
                    for (var i in list) {
                        this.itemCommentList.push(list[i])
                    }
                    if (list.length == 0) {
                        // 数据全部加载完
                        this.finished_item = true
                        // return;
                    }
                } else {
                    this.$toast(res.message)
                    this.finished_item = true
                    // return
                }
                this.pages.page++;
                this.loading_item = false;
            })
        },
        // 切换tab
        changeTab(name) {
            console.log('name', name)
            this.active = name
			if(name == 'a') {
				this.pages.page = 1
				this.goodsCommentList = []
				this.getGoodsComment()
			}else if(name == 'c') {
				this.pages.page = 1
				this.itemCommentList = []
				if (this.loading_item) {
                    return;
                }
                this.loading_item = true;
				this.finished_item = false;
				
				this.getItemComment()
			}
            
        },
        // 展开大图
        zhanshitupian(arr, index) {
			for(let i in arr){
				arr[i] = this.imageUrl+arr[i];
			};
            this.bigTuImgArr = arr;
            this.bigTuShow = true;
            this.bigTuIndex = 0
        },
        // 切换大图
        bigTuChange(index) {
            this.bigTuIndex = index
		},
		// 商品详情页
		goodsDetail(id){
			this.$router.push({
				path: '/shop/detail',
				query: {
					goodsId: id
				}
			})
		},
		// 项目详情页
		itemDetail(id){
			this.$router.push({
				path: '/item/detail',
				query: {
					id: id
				}
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
